export enum StatusProvider {
    TaxMachine = 'TAX_MACHINE',
    Silverfin = 'SILVERFIN',
    Internal = 'INTERNAL',
    Robocorp = 'ROBOCORP',
    ExactOnline = 'EXACT_ONLINE',
    MyMinfin = 'MYMINFIN',
    Yuki = 'YUKI',
}
